import {publishEvent} from '../pub-sub';
import {ANALYTIC_EVENTS} from '../pub-sub/constants';

export const LoginTracker = {
  toLoginButton: {
    fromComments: () => publishEvent(ANALYTIC_EVENTS.LOGIN, {
      action_target: 'open_send_comment_button'
    }),
    fromMenu: () => publishEvent(ANALYTIC_EVENTS.LOGIN, {
      action_target: 'open_menu_enter'
    })
  },
  fromCommentsPreview: () => publishEvent(ANALYTIC_EVENTS.LOGIN, {
    action_target: 'open_send_comment'
  }),
  fromCommentsModal: () => publishEvent(ANALYTIC_EVENTS.LOGIN, {
    action_target: 'open_send_comment_block'
  })
};
